(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  (() => {
    function mountAnnouncement() {
      const banner = document.getElementById('ck-bf-2026-announcement');
      if (!banner || banner.dataset.clockAttached) return;
      banner.dataset.clockAttached = 'true';
      const normal = document.getElementById('ck-bf-2026-normal-announcement');
      const deadline = Number(banner.dataset.endsAt);
      let timer;

      function synchronize() {
        clearTimeout(timer);
        const remaining = deadline - Date.now();
        if (remaining <= 0) {
          banner.remove();
          if (normal) normal.hidden = false;
          document.removeEventListener('visibilitychange', synchronize);
          window.removeEventListener('pageshow', synchronize);
          return;
        }
        timer = setTimeout(synchronize, Math.min(remaining, 2147483647));
      }

      document.addEventListener('visibilitychange', synchronize);
      window.addEventListener('pageshow', synchronize);
      synchronize();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', mountAnnouncement, { once: true });
    } else {
      mountAnnouncement();
    }
    document.addEventListener('shopify:section:load', mountAnnouncement);
  })();

  } catch(e) { console.error(e); }
})();
})();
